import axios from 'axios'
import qs from 'qs' // 引入qs模块，用来序列化post类型的数据
import config from '../config/index' // 路径配置
import { Toast, Dialog } from 'vant'
import store from '../store'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router/index'
// 创建axios 实例
const service = axios.create({
    baseURL: config.baseURL+'/prod-api', // api的base_url
    timeout: 10000 // 请求超时时间

})
service.defaults.withCredentials = true
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// request interceptor
// request 拦截器
service.interceptors.request.use(
    config => {
        // 这里可以自定义一些config 配置
        if (config.method === "post" || config.method === 'put') {
            // post、put 提交时，将对象转换为string, 为处理Java后台解析问题
            config.data = qs.stringify(config.data);
        }
        // console.log(store.getters.token)
        // console.log(getToken())
        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            //   config.headers.post['x-auth-token'] = getToken()
        }
        //   debugger
        return config
    },
    error => {
        //  这里处理一些请求出错的情况

        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
            // 这里处理一些response 正常放回时的逻辑
            // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 20000) {
            Toast({
                message: res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                // to re-login
                Dialog.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
                    confirmButtonText: 'Re-Login',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('user/resetToken').then(() => {
                        location.reload()
                    })
                })
            }
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        // 这里处理一些response 出错时的逻辑
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    // router.replace({
                    //     path: '/login',
                    //     query: {redirect: router.currentRoute.fullPath}
                    // });
                    break;
                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token和清空vuex中token对象
                    // 跳转登录页面
                case 403:
                    Toast({
                        message: '登录过期，请重新登录',
                        duration: 1500,
                        forbidClick: true
                    });
                    // 清除token
                    removeToken();
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    router.replace({
                        path: '/loginOld'
                    });
                    break;
                    // 404请求不存在
                case 404:
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                    // 其他错误，直接抛出错误提示
                default:
                    Toast({
                        message: error.response.data.message,
                        duration: 1500,
                        forbidClick: true
                    });
            }
        }
        return Promise.reject(error)
    }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {

    return new Promise((resolve, reject) => {

        axios.post(url, qs.stringify(params), {
                headers: {
                    'token': getToken()
                }
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(error => {
                if (error.response.status) {
                    switch (error.response.status) {
                        // 401: 未登录
                        // 未登录则跳转登录页面，并携带当前页面的路径
                        // 在登录成功后返回当前页面，这一步需要在登录页操作。
                        case 401:
                            // router.replace({
                            //     path: '/login',
                            //     query: {redirect: router.currentRoute.fullPath}
                            // });
                            break;
                            // 403 token过期
                            // 登录过期对用户进行提示
                            // 清除本地token和清空vuex中token对象
                            // 跳转登录页面
                        case 403:
                            Toast({
                                message: '登录过期，请重新登录',
                                duration: 1500,
                                forbidClick: true
                            });
                            // 清除token
                            removeToken();
                            router.replace({
                                path: '/loginOld'
                            });
                            break;
                            // 404请求不存在
                        case 404:
                            Toast({
                                message: '网络请求不存在404',
                                duration: 1500,
                                forbidClick: true
                            });
                            break;
                            // 404请求不存在
                        case 500:
                            Toast({
                                message: '网络请求出错500',
                                duration: 1500,
                                forbidClick: true
                            });
                            break;
                            // 其他错误，直接抛出错误提示
                        default:
                            Toast({
                                message: error.response.data.message,
                                duration: 1500,
                                forbidClick: true
                            });
                    }
                }
            })
    });
}

export default service